import { useEffect } from "react";

export function useBodyScrollLock(shouldLock: boolean) {
  useEffect(() => {
    const body = document?.body;
    const html = document?.documentElement;

    if (!body || !html) {
      return;
    }

    let scrollY = 0;

    if (shouldLock) {
      scrollY = window.scrollY;
      body.style.position = "fixed";
      body.style.top = `-${scrollY}px`;
      body.style.left = "0";
      body.style.right = "0";
      body.style.width = "100%";
      html.style.overscrollBehavior = "none";
    } else {
      const storedY = body.style.top;
      body.style.position = "";
      body.style.top = "";
      body.style.left = "";
      body.style.right = "";
      body.style.width = "";
      html.style.overscrollBehavior = "";
      if (storedY) {
        window.scrollTo(0, parseInt(storedY || "0") * -1);
      }
    }

    return () => {
      if (!body || !html) {
        return;
      }

      const storedY = body.style.top;
      body.style.position = "";
      body.style.top = "";
      body.style.left = "";
      body.style.right = "";
      body.style.width = "";
      html.style.overscrollBehavior = "";
      if (storedY) {
        window.scrollTo(0, parseInt(storedY || "0") * -1);
      }
    };
  }, [shouldLock]);
}
